<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="api/plm/file/page">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="PC编号">
            <el-input v-model.trim="filter.pCNO" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="文件编号">
            <el-input v-model.trim="filter.fileNo" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="文件名称">
            <el-input v-model.trim="filter.fileName" placeholder="请输入" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column align="center" prop="fileNo" label="文件编号" width="150"/>
      <el-table-column align="center" prop="fileName" label="文件名称" show-overflow-tooltip/>
      <el-table-column align="center" prop="fileVersion" label="版本"/>
      <el-table-column align="center" prop="fileCategory" label="文件分类"/>
      <el-table-column align="center" prop="materialNo" label="物料编号" width="150"/>
      <el-table-column align="center" prop="pCNO" label="PC编号" width="150"/>
      <el-table-column align="center" prop="factoryNo" label="工厂" width="150"/>
      <el-table-column align="center" prop="createTime" label="创建时间" width="160"/>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="download(scope.row)">下载</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "PlmFileList",
    components: {VmTable, VmSearch},
    data() {
      return {
        filter: {
          materialNo: "",
          pCNO: "",
          fileNo: "",
          fileName: "",
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNo) {
        this.$refs.vmTable.getList(pageNo);
      },
      download(row) {
        // const path = row.filePath || row.fileUrl;
        // if (!path) {
        //   this.$message.warning("文件路径为空，无法下载");
        //   return;
        // }
        window.open(window.config.basicServerUrl + "api/plm/filed/" + row.pkid);
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
